import { useContext } from 'react';
import { PaymentContext } from './PaymentContext';
import {
    GenerateDefaultPaymentStatus,
    IPaymentStatus,
    IPaymentStatusHook
} from './PaymentContext.types';

export const usePaymentStatus = (): IPaymentStatusHook => {
    const { attempted, setAttempted, status, setStatus, due, setDue, idiCartId, setIdiCartId } =
        useContext(PaymentContext);

    const handleSetStatus = (item: IPaymentStatus) => {
        window.sessionStorage.setItem('paymentAttempted', 'true');
        window.sessionStorage.setItem('paymentStatus', JSON.stringify(item));
        setAttempted(true);
        setStatus(item);
    };

    const handleSetDue = (amountDue: number) => {
        window.sessionStorage.setItem('due', amountDue.toString());
        setDue(amountDue);
    };

    const handleSetCartId = (cartId: number) => {
        window.sessionStorage.setItem('idiCartId', cartId.toString());
        setIdiCartId(cartId);
    };

    const resetPayment = () => {
        window.sessionStorage.removeItem('paymentAttempted');
        window.sessionStorage.removeItem('paymentStatus');
        setAttempted(false);
        setStatus(GenerateDefaultPaymentStatus());
    };

    return {
        attempted,
        setAttempted,
        status,
        setStatus: handleSetStatus,
        resetPayment,
        due,
        setDue: handleSetDue,
        idiCartId,
        setIdiCartId: handleSetCartId
    };
};
